import styled from 'styled-components';

export const CardBorderContainer = styled.div`
  position: absolute;
  top: -22px;
  bottom: -4px;
  left: -4px;
  right: -4px;
  z-index: -1;
  border-radius: 8px;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimarySelected};
`;

export const BorderText = styled.div`
  font-size: ${({ theme }) => theme.kallisto.font.size['150']}; // 12px
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold}; // 700
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['200']}; // 16px
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};

  text-transform: uppercase;
`;
